import * as React from 'react';
import { Root as Root2, Trigger, Portal } from '../../../../_externals/.pnpm/@radix-ui_react-popover@1.1.1_@types_react@18.3.5_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@radix-ui/react-popover/dist/index.js';
import { TextInputWrap, Input } from '../Form/TextInput/TextInput.styles.js';
import { useAddressSearch } from './useAddressSearch.js';
import { AddressSearchWrap, AddressSearchResults, AddressSearchResult } from './AddressForm.styles.js';

var AddressSearch = function (_a) {
    var apiKey = _a.apiKey, location = _a.location, placeholder = _a.placeholder, onAddressSelect = _a.onAddressSelect;
    var _b = React.useState(""), searchText = _b[0], setSearchText = _b[1];
    var _c = useAddressSearch(apiKey, location, searchText, setSearchText, onAddressSelect), results = _c.results, handleResultClick = _c.handleResultClick, loading = _c.loading;
    var containerRef = React.useRef(null);
    var inputRef = React.useRef(null);
    var handleOnChange = function (e) {
        setSearchText(e.target.value);
    };
    var handleAddressSelect = function (item) {
        handleResultClick(item);
        if (inputRef.current && item.Type !== "Address") {
            inputRef.current.focus();
        }
    };
    return (React.createElement(AddressSearchWrap, { ref: containerRef },
        React.createElement(Root2, null,
            React.createElement(Trigger, { asChild: true },
                React.createElement(TextInputWrap, { loading: loading },
                    React.createElement(Input, { name: "search", "aria-label": "search", type: "input", value: searchText, onChange: handleOnChange, placeholder: placeholder || "", autoComplete: "none", ref: inputRef }))),
            React.createElement(Portal, { container: containerRef.current, forceMount: true },
                React.createElement(AddressSearchResults, { isOpen: (results === null || results === void 0 ? void 0 : results.length) > 0 }, results.map(function (item, index) { return (React.createElement(AddressSearchResult, { type: "button", key: index, onClick: function () { return handleAddressSelect(item); } },
                    item.Text,
                    " ",
                    React.createElement("span", null, item.Description))); }))))));
};

export { AddressSearch as default };
//# sourceMappingURL=AddressSearch.js.map
